import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import DatePicker from 'react-datepicker';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus-gray.svg';
import InputHeader from '../global/inputwithHeader';
import CustomDateInput from '../global/customDateInput';
import _, { forEach } from 'lodash';
// import LoadingBar from '../../../components/global/loadingBar';
//import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
// import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
// import { ReactComponent as MinusIcon } from '../../../../assets/svg/Project/minus-circle.svg';
// import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-gray.svg';
import { withRouter } from '../../../services/withRoute';
// import 'react-datepicker/dist/react-datepicker.css';
// import InputHeader from '../../global/inputwithHeader';
// import CustomDateInput from '../../global/customDateInput';
//import CreatableSelect from 'react-select/creatable';
import Modal from '../../components/modals';
import Select from 'react-select';

import jwt_decode from 'jwt-decode';

import moment from 'moment';
const updateAttendance = gql`
	mutation RootMutation($updateAttendanceInput: UpdateAttendanceInput!, $logId: ID) {
		updateEmpAttendance(updateAttendanceInput: $updateAttendanceInput, logId: $logId) {
			_id
			date
			logins {
				timestamp
			}
			logouts {
				timestamp
			}
			status
			totalHours
			divisionId

			updatedBy
			updatedAt
		}
	}
`;
class EditAttendance extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			note: this.props.modalData.notes,
			attendanceOptions: [
				{ value: 'present', label: 'Present' },
				// { value: 'absent', label: 'Absent' },
				{ value: 'notMarked', label: 'Not Marked' },
			],

			attendance: '',
			selectedattendance: null,
			noteEdited: false,
		};
	}
	handleCloseModal = () => {
		this.props.handleClose();
	};
	handleEventChange = (e, name) => {
		this.setState({
			[name]: e.value,
			[`selected${name}`]: e,
		});
	};
	isDisabled = () => {
		return this.state.selectedattendance === null && this.state.noteEdited == false;
	};
	editAttendanceApiCall = () => {
		let json = {
			logId: this.props.modalData.id,
		};
		if (this.state.selectedattendance !== null) {
			json = {
				...json,
				updateAttendanceInput: {
					...json.updateAttendanceInput,
					status: this.state.attendance,
				},
			};
		}
		if (this.state.note !== null) {
			json = {
				...json,
				updateAttendanceInput: {
					...json.updateAttendanceInput,
					notes: [
						{
							message: this.state.note,
						},
					],
				},
			};
		}

		this.updateAttendance(updateAttendance, json).then(() => {
			this.handleCloseModal();
		});
		// this.props.navigate(`/${this.props.params.vendorID}/tasks`);
		// .then(() => {
		// 	window.location.reload();
		// });
	};
	// EditAttendanceApiCall = () => {
	// 	let json = {
	// 		identifier: this.props.modalData.id,
	// 	};
	// 	if (this.state.selectedbranch !== null) {
	// 		json = {
	// 			...json,
	// 			updateAssetInput: {
	// 				...json.updateAssetInput,
	// 				branch: {
	// 					_id: this.state.selectedbranch.value,
	// 					branchId: this.state.selectedbranch.label,
	// 				},
	// 			},
	// 		};
	// 	}
	// 	if (this.state.selectedassignedTo !== null) {
	// 		json = {
	// 			...json,
	// 			updateAssetInput: {
	// 				...json.updateAssetInput,
	// 				employee: {
	// 					_id: this.state.selectedassignedTo.value,
	// 					name: this.state.selectedassignedTo.label,
	// 				},
	// 			},
	// 		};
	// 	}
	// 	if (this.state.selectedstatus !== null) {
	// 		json = {
	// 			...json,
	// 			updateAssetInput: {
	// 				...json.updateAssetInput,
	// 				status: this.state.selectedstatus.value,
	// 			},
	// 		};
	// 	}
	// 	this.updateAsset(updateAsset, json)
	// 		.then(() => {
	// 			this.handleCloseModal();
	// 		})
	// 		.then(() => {
	// 			window.location.reload();
	// 		});
	// };
	render() {
		console.log(
			'checking props data =====> modaldata',
			this.props.modalData,
			'selecteddata====>',
			this.state.selectedbranch,
			this.state.selectedassignedTo,
			this.state.selectedstatus,
		);
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
				custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				<div className="project-add-edit-popup edit-shoot-details">
					<div
						className="project-add-edit-popup-header"
						style={{
							alignItems: this.props.activeShootID == null ? 'center' : 'flex-start',
							flexDirection: this.props.activeShootID == null ? 'row' : 'column',
							height: this.props.activeShootID == null ? '56px' : '70px',
						}}
					>
						<span className="header-title">Megha Paul</span>
					</div>

					<div className="project-add-edit-popup-body">
						<div className="project-add-edit-popup-body-item" id={'details'}>
							<div className="popup-body-title">EMPLOYEE DETAILS</div>

							{/* <div className="floating-select-container"></div> */}

							<InputHeader
								type="text"
								name="Date"
								value={this.props.modalData.date}
								readOnly={true}
								onChange={(e) => {}}
								isInputError={false}
								label="Date"
							/>
							<InputHeader
								type="text"
								name="clockIn"
								value={this.props.modalData.clockins}
								readOnly={true}
								onChange={(e) => {}}
								isInputError={false}
								label="Clock In"
							/>
							<InputHeader
								type="text"
								name="clockOut"
								value={this.props.modalData.clockouts}
								readOnly={true}
								onChange={(e) => {}}
								isInputError={false}
								label="Clock Out"
							/>
							<div className="floating-select-container">
								<label>Attendance State</label>
								<Select
									className="cost-select-container zIndex31 w-100p"
									classNamePrefix="cost-select"
									options={this.state.attendanceOptions}
									onChange={(e) => this.handleEventChange(e, 'attendance')}
									defaultValue={this.props.modalData.attendanceState}
									// isSearchable={true}
									// menuPortalTarget={document.body}
									menuPosition={'fixed'}
									// onMenuScrollToBottom={(e) => this.fetchMoreOptions()}
								/>
							</div>
							<InputHeader
								type="text"
								name="notes"
								value={this.state.note}
								readOnly={false}
								onChange={(e) => {
									this.setState({
										note: e.target.value,
										noteEdited: true,
									});
								}}
								isInputError={false}
								label="Note"
							/>
						</div>
					</div>

					<div className="bottom-popup-action-container">
						<span className="cancel-btn" onClick={() => this.handleCloseModal()}>
							Cancel
						</span>

						<span
							className={this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'}
							onClick={(e) => {
								// this.EditAttendanceApiCall();
								if (!this.isDisabled()) {
									this.editAttendanceApiCall();
								}
							}}
						>
							<span>Save</span>
						</span>
					</div>
				</div>
			</Modal>
		);
	}
}
export default withRouter(EditAttendance);
